(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-coupon-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fallbackCopy = (text) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();
      return copied;
    };

    if (!window.__mmCouponCopyBound) {
      window.__mmCouponCopyBound = true;
      document.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-mm-copy-coupon]');
        if (!button) return;
        const code = button.dataset.couponCode || '';
        if (!code) return;
        let copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
            copied = true;
          } else copied = fallbackCopy(code);
        } catch (_) { copied = fallbackCopy(code); }
        if (!copied) return;
        const label = button.querySelector('[data-mm-copy-label]');
        const status = button.parentElement.querySelector('[data-mm-copy-status]');
        const copiedLabel = button.dataset.copiedLabel || 'Copiado!';
        const defaultLabel = button.dataset.copyLabel || 'Copiar';
        if (label) label.textContent = copiedLabel;
        if (status) status.textContent = `${code} copiado para a área de transferência.`;
        button.classList.add('is-copied');
        window.setTimeout(() => {
          if (label) label.textContent = defaultLabel;
          if (status) status.textContent = '';
          button.classList.remove('is-copied');
        }, 1800);
      });
    }

    const initCarousel = (carousel) => {
      if (!carousel || carousel.dataset.mmCarouselReady === 'true') return;
      carousel.dataset.mmCarouselReady = 'true';
      const track = carousel.querySelector('[data-mm-coupon-track]');
      const nav = carousel.querySelector('[data-mm-coupon-nav]');
      const prev = carousel.querySelector('[data-mm-coupon-prev]');
      const next = carousel.querySelector('[data-mm-coupon-next]');
      if (!track || !nav || !prev || !next) return;

      const step = () => {
        const card = track.querySelector('.mm-coupon-section__card-wrap:not(:empty)');
        if (!card) return Math.max(track.clientWidth * .8, 280);
        const gap = parseFloat(getComputedStyle(track).gap) || 10;
        return card.getBoundingClientRect().width + gap;
      };

      const update = () => {
        if (window.matchMedia('(max-width: 767px)').matches) {
          nav.hidden = true;
          return;
        }
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const scrollable = max > 3;
        nav.hidden = !scrollable;
        prev.disabled = track.scrollLeft <= 3;
        next.disabled = track.scrollLeft >= max - 3;
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      requestAnimationFrame(update);
    };

    const initAll = (root = document) => root.querySelectorAll('[data-mm-coupon-carousel]').forEach(initCarousel);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
